import React, { useState, useEffect } from 'react';
import './style.css';
import Header_home from './Header_home';
import Footer from './Footer';
import Menu from './Menu';
import Prductslide from './Prductslide';
import axios from 'axios';
import Product_detail1 from './Product_detail1';
import Product_sidebar from './Product_sidebar';
// import Loader from "react-loader-spinner";
// import { Puff } from "react-loader-spinner";
class Features extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      api_url: localStorage.getItem('api_url'),
      category_id: localStorage.getItem('category_id'),
      data: [],
      product: {},
      product_detail: [],
      category_detail: [],
      subcategory_detail: [],
      prescription: 'no',
      search: '',
      suc_cls: '',
      errors: {},
      openModal: false,
      pic: '',
      fileName: '',
      email: '',
      email1: '',
      password: '',
      loading: true, // Initialize loading state here
    };
  }

  

  render() {
    return (

      
      <div className="">

          {/* <div className={this.state.showBlur ? "blur" : ""}>
              
              {this.state.loading ? (
                <div className="loader-wrapper">
                  <Puff type="Puff" color="#00BFFF" height={100} width={100} />
                </div>
              ) : (
                <div>Loading please wait...</div>
              )}
        </div> */}
        {<Header_home />}
        <div className="short_line">
          <p className="short_text">Home /Features</p>
        </div>
        <div class="container">
  
          
            <Product_detail1 />
          
          
        </div>
        <br></br>
        <br></br>
        <div className='sell_best_product'>
          <h2 className="">Recently Viewed Products</h2>
          <Prductslide />
          <br></br>
          <br></br>
          <br></br>
        </div>
        {<Footer />}
      </div>
    );
  }
}

export default Features;
